import _Steps from './Steps';

import './style/index.js';

export type { StepsProps } from './Steps';
export type { StepItemProps } from './StepItem';
export * from './type';

export const Steps = _Steps;
export default Steps;
